import { useState } from 'react';

export default function EditPopState() {
  // 重新翻译弹窗状态
  const [translatePop, setTranslatePop] = useState(false);
  // tts弹窗状态-原文
  const [ttsOriginalPop, setTtsOriginalPop] = useState(false);
  // tts弹窗状态-译文
  const [ttstranslationPop, setTtstranslationPop] = useState(false);
  // 导出弹窗
  const [ExportPop, setExportPop] = useState(false);
  // 创建副本弹窗
  const [copeProjectPop, setCopeProjectPop] = useState(false);
  // 水印支付弹窗
  const [watermarkPayPop, setWatermarkPayPop] = useState(false);
  // 导出支付弹窗
  const [exportPayPop, setExportPayPop] = useState(false);
  // 单句翻译
  const [sentenceTranslationPopup, setSentenceTranslationPopup] = useState(false);

  return {
    translatePop,
    setTranslatePop,
    ttsOriginalPop,
    setTtsOriginalPop,
    ttstranslationPop,
    setTtstranslationPop,
    ExportPop,
    setExportPop,
    copeProjectPop,
    setCopeProjectPop,
    watermarkPayPop,
    setWatermarkPayPop,
    exportPayPop,
    setExportPayPop,
    sentenceTranslationPopup,
    setSentenceTranslationPopup,
  };
}
